import { n as s } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "NcAppContentList",
  props: {
    selection: {
      type: Boolean,
      default: !1
    },
    showDetails: {
      type: Boolean,
      default: !1
    }
  }
};
var l = function() {
  var e = this, t = e._self._c;
  return t("div", { staticClass: "app-content-list", class: { selection: e.selection, showdetails: e.showDetails } }, [e._t("default")], 2);
}, a = [], o = /* @__PURE__ */ s(
  n,
  l,
  a,
  !1,
  null,
  null,
  null,
  null
);
const r = o.exports;
export {
  r as default
};
